import { PackagesView } from "components/PackagesView/PackagesView";
import {
  filteredPackagesState,
  orderedPackagesAtom,
  packagesSearchFilterValueState,
  selectedCompanyState,
  selectedCountryState,
} from "store/UiHrPackagesPage";

export function HrPackagesPage() {
  return (
    <>
      <PackagesView
        orderedPackagesAtom={orderedPackagesAtom}
        filteredPackageAtom={filteredPackagesState}
        searchFilterAtom={packagesSearchFilterValueState}
        selectedCompanyAtom={selectedCompanyState}
        selectedCountryAtom={selectedCountryState}
      />
    </>
  );
}

export default HrPackagesPage;
